<div fxLayout="column" class="card-container">

  <div fxLayout="row wrap" fxFlex="33.33" *ngFor="let slide of rateList"  [style.height]="item.height">

    <div   [style.background-color]="item.customField8">

      <div class="card-image">
        <img [src]="serverPath1 + slide.value" [alt]="slide.value">
      </div>

      <div class="card-content" fxLayout="column" fxLayoutAlign="center center">
        <h3>{{slide.name}}</h3>
        <p>{{slide.price | currencyConvert }}</p>
      </div>

    </div>

   
   

  </div>



</div>